module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo9-42d938774cdfa086135e76b2193bc17f.jpg";